import { create } from 'zustand';
import { createSelectors } from './createSelectors';
import { listRouteStops, RouteStopListItem, RouteStopListRequest } from '../apis/serviceHistoryApi';
import { add as dateAdd } from 'date-fns';

interface TableState {
  page: number;
  rowsPerPage: number;
  filter: RouteStopListRequest;
  rows: RouteStopListItem[];
}

const initFilterCriteria = () => ({ toDate: new Date(), fromDate: dateAdd(new Date(), { years: -1 }) });
export const getInitialTableState = () => ({ page: 0, rowsPerPage: 10, filter: initFilterCriteria(), rows: [] });

interface RouteStopState {
  tableState: TableState;
  clearTableData: () => void;
  setListPage: (page: number) => void;
  setListRowsPerPage: (rowsPerPage: number) => void;
  applyFilter: (filter: RouteStopListRequest) => Promise<RouteStopListItem[]>;
}

const useServiceHistoryStoreBase = create<RouteStopState>((set, get) => ({
  tableState: getInitialTableState(),
  clearTableData: () => set({ tableState: getInitialTableState() }),
  setListPage: (page: number) => set({ tableState: { ...get().tableState, page } }),
  setListRowsPerPage: (rowsPerPage: number) => set({ tableState: { ...get().tableState, rowsPerPage } }),
  applyFilter: async (filter: RouteStopListRequest) => {
    let listRows: RouteStopListItem[] = [];
    if (filter.fromDate <= filter.toDate) {
      listRows = await listRouteStops(filter);
    }
    const rowsPerPage = get().tableState.rowsPerPage;
    set({ tableState: { ...getInitialTableState(), rows: listRows, filter, rowsPerPage } });
    return listRows;
  },
}));

export const useServiceHistoryStore = createSelectors(useServiceHistoryStoreBase);
